import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const ADD_ACCOUNT_NOTE = gql`
  mutation AddAccountNote($input: AddAccountNoteInput!) {
    addAccountNote(input: $input) {
      id
      title
      note
      type
      image
      image_id
      created_at
      created_by {
        id
        formatted_name
      }
    }
  }
`;

export function useAddAccountNote() {
  const [addAccountNoteMutation, { loading }] = useMutation(ADD_ACCOUNT_NOTE);

  const addAccountNote = useCallback(
    async (input) => {
      try {
        const result = await addAccountNoteMutation({
          variables: { input },
        });
        return { success: true, data: result.data?.addAccountNote };
      } catch (error) {
        return { success: false, error: error.message };
      }
    },
    [addAccountNoteMutation]
  );

  return { addAccountNote, loading };
}
